module.exports = __webpack_public_path__ + "static/media/07-quiz.6b726554.png";